import {
  getURIQueryParams as getQueryParams,
  cleanURIQueryParams,
  setURIQueryParams,
} from "@accessdev/arc-ui-react/utils/js";

const toParamString = (params) => {
  return setURIQueryParams(cleanURIQueryParams(params));
};

const arrayToParamString = (values, key) => values.map((value) => `${key}[]=${value}`).join("&");

export { getQueryParams, toParamString, arrayToParamString };
